import { GlobalStore } from "store/global/GlobalStore";

export const useTokenListByChain = () => {
  const tokenLists = GlobalStore.useState(s => s.tokenLists);
  const network = GlobalStore.useState(s => s.network);
  return tokenLists?.[network.id];
};
